import React from "react";
import filter from "lodash/filter";
import escapeRegExp from "lodash/escapeRegExp";
import { Search } from "semantic-ui-react";

class CustomSearch extends React.Component {
  state = { value: "", seleccion: null };

  componentWillMount() {
    this.resetComponent();
  }

  componentWillReceiveProps(nextProps) {
    nextProps.value === "reset" && this.resetComponent();
  }

  resetComponent = () => {
    this.setState({
      isLoading: false,
      results: [],
      value: "",
      seleccion: null
    });
    this.props.handleReset && this.props.handleReset();
  };

  handleResultSelect = (e, { result }) => {
    this.setState({ value: result.title, seleccion: result });
    this.props.onSelect(result.childKey);
  };

  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: true, value });
    this.props.onChange && this.props.onChange(value);

    setTimeout(() => {
      if (this.state.value.length < 1) return this.resetComponent();

      const re = new RegExp(escapeRegExp(this.state.value), "i");
      const isMatch = result => re.test(result.title);

      this.setState(state => ({
        value,
        isLoading: false,
        results: filter(this.props.datosBusqueda, isMatch)
      }));
    }, 50);
  };

  render() {
    const { isLoading, value, results } = this.state;

    return (
      <Search
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        results={results}
        value={value}
        noResultsMessage="Sin resultados"
        fluid={this.props.fluid}
      />
    );
  }
}

export default CustomSearch;



// WEBPACK FOOTER //
// ./src/pages/shared/CustomSearch.jsx